/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScoringParameters } from '../../models/scoring-parameters';

export interface DeleteScoringParameters$Params {
  scoringParameterId: number;
}

export function deleteScoringParameters(http: HttpClient, rootUrl: string, params: DeleteScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<ScoringParameters>> {
  const rb = new RequestBuilder(rootUrl, deleteScoringParameters.PATH, 'delete');
  if (params) {
    rb.path('scoringParameterId', params.scoringParameterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScoringParameters>;
    })
  );
}

deleteScoringParameters.PATH = '/api/scoringparameters/{scoringParameterId}';
